export const es = {
  title: 'Paisajes forestales intactos',
  subtitle: '(2000/2013/2016/2020)',
  download_data: 'https://data.globalforestwatch.org/documents/gfw::intact-forest-landscapes/about',
  learn_more: 'http://www.intactforests.org/',
  content: [
    {
      label: 'Función',
      value:
        'Identifica los últimos paisajes forestales no fragmentados que quedan en el mundo, los cuales son lo suficientemente grandes como para preservar toda la biodiversidad autóctona y no mostrar signos de alteración humana hasta el año 2020. Esta capa también muestra la reducción de la extensión de los Paisajes Forestales Intactos (IFL) de 2000 a 2020.',
    },
    {
      label: 'Resolución',
      value: 'Aproximadamente 1:1 000 000',
    },
    {
      label: 'Cobertura geográfica',
      value: 'Global',
    },
    {
      label: 'Fuente',
      value:
        'Potapov, P., M. C. Hansen, L. Laestadius, S. Turubanova, A. Yaroshenko, C. Thies, W. Smith, I. Zhuravleva, A. Komarova, S. Minnemeyer, and E. Esipova. 2017. "The last frontiers of wilderness: Tracking loss of intact forest landscapes from 2000 to 2013." Science Advances 3: e1600821.',
    },
    {
      label: 'Fecha del contenido',
      value: 2020,
    },
    {
      label: 'Precauciones',
      value:
        'El mapa del mundo IFL fue creado mediante la interpretación visual de las imágenes Landsat por parte de los expertos. El mapa puede contener imprecisiones debidas a las limitaciones de la resolución espacial de las imágenes y la falta de información auxiliar acerca de las prácticas locales de uso del suelo en algunas regiones. Además, la metodología supone que los incendios en proximidad a las carreteras u otras infraestructuras pueden haber sido causados por los seres humanos, y por lo tanto constituyen una forma de perturbaciones antropogénicas. Esta hipótesis podría dar lugar a una subestimación del alcance de IFL en el bioma boreal.',
    },
    {
      label: 'Licencia',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: 'Descripción',
    value:
      'El conjunto de datos de los Paisajes Forestales Intactos (PFI) identifica extensiones ininterrumpidas de ecosistemas naturales dentro de la zona de extensión forestal que no muestran señales de actividad humana significativa y que son lo suficientemente grandes como para conservar toda la biodiversidad nativa, incluyendo a poblaciones viables de especies de amplio espectro. Para realizar los mapas de PFI se desarrolló y diseñó un conjunto de criterios para aplicar globalmente y replicar fácilmente, y esto último para permitir evaluaciones repetidas a lo largo del tiempo, así como una verificación. Las áreas de PFI fueron definidas como paisajes no fragmentados de al menos 50 000 hectáreas de extensión y con un ancho mínimo de 10 kilómetros. Estas fueron posteriormente mapeadas a partir de imágenes satelitales Landsat del año 2000.',
  },
  citation: {
    label: 'Citación',
    value:
      'Greenpeace, University of Maryland, World Resources Institute and Transparent World. “Intact Forest Landscapes. 2000/2013/2016/2020” Accessed through Global Forest Watch on 31/01/2025. www.globalforestwatch.org',
  },
};
